import { GetWorkerConnectionsTabQuery } from 'apollo/generated/client-operations';
import { ConnectionColumn, getConnectionColumns } from 'connectors/components';

export type WorkerConnection =
  GetWorkerConnectionsTabQuery['getWorker']['connections'][number];
export type WorkerConnectionColumn = ConnectionColumn;

export const getColumns = (): WorkerConnectionColumn[] =>
  getConnectionColumns();
